'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import CampaignsTable from 'AdsUI/components/campaigns/CampaignsTable';
import { getCampaignList, getCampaignListRequestStatus, getCampaignListEarlyRequestRequestStatus } from 'AdsUI/selectors/CampaignListSelectors';
import { getErrorsByAdAccount, getAdAccounts } from 'AdsUI/selectors/AccountsSelectors';
import { getCampaignListColumns, getColumnsRequestStatus, getColumnDisplayLabels } from 'AdsUI/selectors/ColumnsSelectors';
import { getLifecycleStageLabelsByStageId } from 'AdsUI/selectors/LifecycleStageSelectors';
import { fetchAllLifecycleStages } from 'AdsUI/actions/LifecycleStageActions';
import { fetchColumnsWithEarlyRequester } from 'AdsUI/actions/ColumnActions';
import { ALL_NETWORKS, EntityTypes, Networks } from 'AdsUI/lib/Constants';
import { usageTracker } from 'AdsUI/lib/usageTracker';
import { getToggledEntityStatus } from 'AdsUI/lib/Utils';
import { updateReportingEntityStatus } from 'AdsUI/actions/CampaignReportingActions';
import { hasWriteScope, hasAccessToRoiReporting, hasAdsProScope, hasFacebookLocalCache, getGoogleEnhancedConversionsGate } from 'AdsUI/selectors/AuthSelectors';
import { getRequestStatus } from 'AdsUI/selectors/RequestStatusSelectors';
import { setColumns } from 'AdsUI/actions/ColumnActions';
import { getGlobalFilters, filtersIncludeFacebookStaleDateRange } from 'AdsUI/selectors/GlobalFilters';
import { addHeaderBanner } from 'AdsUI/actions/BannerActions';
import BannerTypes from 'AdsUI/lib/BannerTypes';
import { SEEN_ENHANCED_CONVERSION_BANNER } from '../../lib/StorageKeys';
import AdsSafeStorage from '../../lib/AdsSafeStorage';

class CampaignsTableContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.toggleCampaignStatus = this.toggleCampaignStatus.bind(this);
    this.onColumnReorder = this.onColumnReorder.bind(this);
  }

  componentDidMount() {
    const {
      columnOrderRequestStatus,
      lifecycleStagesRequestStatus,
      adAccounts,
      hasRoiReporting,
      hasGoogleEC
    } = this.props;

    if (!columnOrderRequestStatus.fetched) {
      this.props.fetchColumns();
    }

    if (!lifecycleStagesRequestStatus.fetched) {
      this.props.fetchAllLifecycleStages();
    }

    const hasAdwords = adAccounts.find(account => account.network === Networks.ADWORDS);
    const showEnhancedConversionBanner = !AdsSafeStorage.getItem(SEEN_ENHANCED_CONVERSION_BANNER); // hasRoiReporting = hasProOrEnterprise

    if (hasGoogleEC && hasAdwords && hasRoiReporting && showEnhancedConversionBanner) {
      this.props.addBanner(BannerTypes.ENHANCED_CONVERSIONS, []);
      AdsSafeStorage.setItem(SEEN_ENHANCED_CONVERSION_BANNER, true);
    }
  }

  toggleCampaignStatus(campaignEntity) {
    const {
      network,
      accountId,
      status
    } = campaignEntity;
    const {
      adAccounts
    } = this.props;
    const adAccount = adAccounts.find(account => account.accountId === accountId && account.network === network);
    usageTracker.track('modifyCampaign', {
      action: 'Toggled entity status',
      entityType: EntityTypes.CAMPAIGN,
      network
    });
    this.props.updateReportingEntityStatus(network, adAccount, campaignEntity, EntityTypes.CAMPAIGN, false, null, getToggledEntityStatus(status, network));
  }

  onColumnReorder(columnToMove, locationColumn) {
    const {
      columns
    } = this.props;
    const newColumns = columns.delete(columns.indexOf(columnToMove)).insert(columns.indexOf(locationColumn), columnToMove);
    this.props.setColumns(EntityTypes.CAMPAIGN, ALL_NETWORKS, newColumns.toArray());
    usageTracker.track('changeColumnOrder', {
      action: 'Dragged and dropped columns',
      grouping: 'ads',
      network: ALL_NETWORKS
    });
  }

  render() {
    const {
      campaignList,
      campaignListRS,
      campaignListEarlyRequestRS,
      columns,
      columnOrderRequestStatus,
      lifecycleStageLabelsByStageId,
      globalFilters,
      adAccounts,
      hasWrite,
      hasRoiReporting,
      errorsByAdAccount,
      columnDisplayLabels,
      showFBStaleDataAlert
    } = this.props;
    const columnsLoading = !columnOrderRequestStatus.fetched;
    return /*#__PURE__*/_jsx(Fragment, {
      children: /*#__PURE__*/_jsx(CampaignsTable, {
        loaded: (campaignListEarlyRequestRS.fetchedSuccessfully() || campaignListRS.fetchedSuccessfully()) && !columnsLoading,
        columns: columns,
        lifecycleStageLabelsByStageId: lifecycleStageLabelsByStageId,
        campaignData: campaignList,
        campaigns: campaignList.campaigns,
        adAccounts: adAccounts,
        globalFilters: globalFilters,
        toggleCampaignStatus: this.toggleCampaignStatus,
        hasWriteScope: hasWrite,
        hasRoiReportingScope: hasRoiReporting,
        errorsByAdAccount: errorsByAdAccount,
        onColumnReorder: this.onColumnReorder,
        columnDisplayLabels: columnDisplayLabels,
        showFBStaleDataAlert: showFBStaleDataAlert
      })
    });
  }

}

function select(state) {
  return {
    campaignList: getCampaignList(state),
    campaignListRS: getCampaignListRequestStatus(state),
    campaignListEarlyRequestRS: getCampaignListEarlyRequestRequestStatus(state),
    globalFilters: getGlobalFilters(state),
    adAccounts: getAdAccounts(state),
    columns: getCampaignListColumns(state),
    lifecycleStageLabelsByStageId: getLifecycleStageLabelsByStageId(state),
    columnOrderRequestStatus: getColumnsRequestStatus(state),
    lifecycleStagesRequestStatus: getRequestStatus('lifecycleStages')(state),
    hasWrite: hasWriteScope(state),
    hasAdsPro: hasAdsProScope(state),
    hasRoiReporting: hasAccessToRoiReporting(state),
    errorsByAdAccount: getErrorsByAdAccount(state),
    columnDisplayLabels: getColumnDisplayLabels(state),
    showFBStaleDataAlert: hasFacebookLocalCache(state) && filtersIncludeFacebookStaleDateRange(state),
    hasGoogleEC: getGoogleEnhancedConversionsGate(state)
  };
}

const mapDispatchToProps = {
  fetchColumns: fetchColumnsWithEarlyRequester,
  fetchAllLifecycleStages,
  updateReportingEntityStatus,
  setColumns,
  addBanner: addHeaderBanner
};
export default connect(select, mapDispatchToProps)(CampaignsTableContainer);